module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/tankodrome-lvl3-50.9ecf8428.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/tankodrome-lvl3-50.png
// module id = 3559
// module chunks = 11